<template>
  <footer class="footer">

      <a class="footer__logo" href="/" >
        <img class="footer__logo-svg" src="/logo.svg" alt="Just Cuts">
      </a>

      <div class="footer__divider"></div>

      <div class="footer__nav">
          <div class="footer__nav-column" v-for="nav_link in nav.list">
            <a class="footer__nav-heading" :href="nav_link.path" >{{ nav_link.title }}</a>

            <div class="footer__nav-links">
              <a class="footer__nav-link" v-for="child_link in nav_link.children" :href="child_link.path">
                {{ child_link.title }}
              </a>
            </div>
          </div>
      </div>

    <div class="footer__divider"></div>

     <div class="footer__right">
       <div class="footer__right-panel">
         <h4 class="footer__right-heading">Join us on socials</h4>
         <a class="footer__social-icon" href="https://www.facebook.com/profile.php?id=61588874740200" target="_blank" aria-label="Facebook">
           <img src="/icon-facebook.svg" alt="Facebook" loading="lazy" width="24" height="24">
         </a>
         <a class="footer__social-icon" href="https://www.instagram.com/justcutsofficial/" target="_blank" aria-label="Instagram">
           <img src="/icon-instagram.svg" alt="Instagram" loading="lazy" width="24" height="24">
         </a>
         <a class="footer__social-icon" href="https://www.tiktok.com/@justcutsofficial" target="_blank" aria-label="TikTok">
           <img src="/icon-tiktok.svg" alt="TikTok" loading="lazy" width="24" height="24">
         </a>
         <a class="footer__social-icon" href="https://www.youtube.com/user/JustCutsTV" target="_blank" aria-label="Youtube">
           <img src="/icon-youtube.svg" alt="Youtube" loading="lazy" width="24" height="24">
         </a>
         <a class="footer__social-icon" href="https://www.linkedin.com/company/just-cuts-" target="_blank" aria-label="LinkedIn">
           <img src="/icon-linkedin.svg" alt="Linked In" loading="lazy" width="24" height="24">
         </a>
       </div>


       <div class="footer__vertical-divider"></div>

       <div class="footer__right-panel">
         <h4 class="footer__right-heading">Exclusive stockist of</h4>
         <a class="footer__justice-link" href="https://justicehair.com.au/" target="_blank">
           <svg class="footer__justice-svg" viewBox="0 0 1237.82 398.37">
             <path d="m429.62,171.13h26.61c1.75,9.48,4.72,16.89,8.89,22.23,7.92,10.08,19.24,15.11,33.95,15.11,10.98,0,19.41-2.55,25.3-7.65,5.99-5.19,8.99-11.19,9-17.98,0-6.45-2.84-12.22-8.5-17.31-5.66-5.11-18.78-9.91-39.38-14.45-22.5-5.06-40.7-11.2-54.59-18.48v20.02c0,6.32-.43,12.5-1.29,18.52m611.46,60.46c-7.34,6.71-15.66,12.13-24.95,16.26-14.37,6.45-32.72,9.68-55,9.68-27.06,0-49.19-3.91-66.38-11.71-17.11-7.93-31.87-21.79-44.33-41.6-1.26-2.03-2.48-4.1-3.63-6.26v55.16h-77.06V65.7h-75.96v187.42h-76.92V65.7l-18.26.05h-74.81c-2.15-4.93-5.01-8.84-8.58-11.77-6.11-5.09-14.6-7.64-25.46-7.64-8.95,0-15.68,1.93-20.21,5.77-4.52,3.75-6.79,8.32-6.79,13.75,0,3.97,1.86,7.52,5.6,10.7,3.62,3.27,12.22,6.34,25.8,9.16,33.62,7.25,57.66,14.61,72.15,22.07,14.6,7.38,25.18,16.54,31.76,27.51,6.67,10.98,10,23.25,10.01,36.84,0,15.95-4.41,30.67-13.24,44.15-8.83,13.46-21.17,23.7-37.02,30.72-15.85,6.91-35.81,10.34-59.92,10.34-42.33,0-71.65-8.14-87.94-24.45-2-1.99-3.89-4.05-5.67-6.18-11.62,11.69-21.87,18.53-32.62,22.49-14.94,5.54-32.88,8.32-53.82,8.32-12.11,0-25.35-.84-39.72-2.54-14.26-1.7-26.2-5.04-35.82-10.02-9.62-5.09-18.45-12.27-26.48-21.55-7.92-9.29-13.36-18.85-16.29-28.7l-2.47-8.92c-1.18,7.07-2.67,13.28-4.5,18.6-4.99,14.82-15.11,27.38-30.39,37.68-15.17,10.31-34.63,15.45-58.4,15.45-25.12,0-44.59-3.39-58.4-10.2-13.81-6.78-24.51-16.67-32.09-29.7C5.82,204.56-.58,182.42.04,159.36h73.9c-.66,9.21,1.28,20.64,2.48,24.16,1.81,5.32,4.86,9.62,9.17,12.91,2.93,2.16,7.13,3.21,12.56,3.21,8.6,0,14.88-3.16,18.85-9.5,4.08-6.45,6.11-17.27,6.11-32.43V4.23h146.01v151.95c0,13.57,3.74,24.22,11.2,31.91,7.59,7.59,18.05,11.38,31.41,11.38s23.59-3.73,31.06-11.2c7.58-7.59,11.37-18.27,11.37-32.09V4.23h76.74v8.04l5.19-2.43c14.94-6.56,35.36-9.84,61.29-9.84,15.48,0,29.16,1.43,41.04,4.23h308.37v53.36c4.78-9.1,10.68-17.2,17.74-24.32C886.48,11.07,917.48,0,957.56,0c31.34,0,55.97,6.34,73.83,19,3.41,2.38,6.62,5.01,9.68,7.9V4.23h196.75v53.15h-119.69v39.54h90.73v50.76h-90.73v49.06h119.69v56.37h-196.75v-21.53Zm-34.62-80.17l34.62,10.47v-77.71l-37.5,8.33c-2.4-7.57-4.88-13.12-7.49-16.64-4.3-5.88-9.57-10.41-15.79-13.57-6.23-3.18-13.18-4.77-20.87-4.77-17.43,0-30.79,7.02-40.06,21.04-7.04,10.43-10.54,26.77-10.54,49.06,0,27.63,4.18,46.6,12.58,56.89,8.37,10.18,20.14,15.27,35.31,15.27s25.78-4.13,33.27-12.4c7.57-8.25,13.07-20.25,16.47-35.99"></path><path class="b" d="m8.58,317.96h10.45v33.77h41.36v-33.77h10.45v78.54h-10.45v-35.97H19.03v35.97h-10.45v-78.54Z"></path><path class="b" d="m197.78,317.96h11.55l30.69,78.54h-11.55l-8.58-23.65h-33.22l-8.8,23.65h-10.78l30.69-78.54Zm-7.81,46.09h26.62l-13.09-36.63h-.22l-13.31,36.63Z"></path><path class="b" d="m336.6,317.96h10.45v78.54h-10.45v-78.54Z"></path><path class="b" d="m453.09,317.96h36.96c14.74,0,23.87,8.03,23.87,20.57,0,9.46-4.18,17.27-13.64,19.91v.22c9.13,1.76,11,8.47,11.77,16.17.66,7.7.22,16.28,4.62,21.67h-11.66c-2.97-3.19-1.32-11.66-2.86-19.36-1.1-7.7-2.97-14.19-13.09-14.19h-25.52v33.55h-10.45v-78.54Zm32.23,36.19c9.79,0,18.15-2.53,18.15-13.97,0-7.7-4.18-13.42-13.97-13.42h-25.96v27.39h21.78Z"></path><path class="b" d="m672.1,341.61c-2.2-11.11-11.11-16.72-22-16.72-18.7,0-26.62,15.4-26.62,31.79,0,17.93,7.92,32.89,26.73,32.89,13.75,0,21.67-9.68,22.66-22.66h10.45c-1.98,19.58-14.19,31.46-33.99,31.46-24.42,0-36.3-18.04-36.3-40.92s12.98-41.36,37.18-41.36c16.39,0,29.92,8.8,32.34,25.52h-10.45Z"></path><path class="b" d="m806.07,317.96h11.55l30.69,78.54h-11.55l-8.58-23.65h-33.22l-8.8,23.65h-10.78l30.69-78.54Zm-7.81,46.09h26.62l-13.09-36.63h-.22l-13.31,36.63Z"></path><path class="b" d="m944.45,317.96h36.96c14.74,0,23.87,8.03,23.87,20.57,0,9.46-4.18,17.27-13.64,19.91v.22c9.13,1.76,11,8.47,11.77,16.17.66,7.7.22,16.28,4.62,21.67h-11.66c-2.97-3.19-1.32-11.66-2.86-19.36-1.1-7.7-2.97-14.19-13.09-14.19h-25.52v33.55h-10.45v-78.54Zm32.23,36.19c9.79,0,18.15-2.53,18.15-13.97,0-7.7-4.18-13.42-13.97-13.42h-25.96v27.39h21.78Z"></path><path class="b" d="m1108.24,317.96h54.23v8.8h-43.78v24.97h40.81v8.8h-40.81v27.17h44.11v8.8h-54.56v-78.54Z"></path><polygon points="1192.92 317.6 1183.52 317.6 1183.52 314.44 1206.08 314.44 1206.08 317.6 1196.67 317.6 1196.67 342.65 1192.92 342.65 1192.92 317.6"></polygon><polygon points="1209.28 314.44 1214.42 314.44 1223.31 338.15 1232.24 314.44 1237.37 314.44 1237.37 342.65 1233.82 342.65 1233.82 319.18 1233.74 319.18 1224.93 342.65 1221.73 342.65 1212.92 319.18 1212.84 319.18 1212.84 342.65 1209.28 342.65 1209.28 314.44"></polygon>
           </svg>
         </a>
       </div>


       <!--
              <div class="footer__right-panel">
                <h4 class="footer__right-heading">Download Our App</h4>
                <a class="footer__app-icon" href="https://itunes.apple.com/au/app/just-cuts/id1296024711?mt=8" target="_blank" aria-label="Apple App Store">
                  <img src="/logo-app-store.svg" alt="Download Our App" loading="lazy" width="88" height="30">
                </a>
                <a class="footer__app-icon" href="https://play.google.com/store/apps/details?id=com.shift8.justcuts" target="_blank" aria-label="Google Play Store">
                  <img src="/logo-google-play.png" alt="Download Our App" loading="lazy" width="564" height="168">
                </a>
              </div>
              -->
     </div>

      <!--
      <div class="footer__copyright">
        © Copyright 2023. All Rights Reserved Just Cuts
      </div>
      -->

  </footer>
</template>


<script>

import NavigationList from "../../models/NavigationList";

export default {

  data(){
    return{
      nav: [],
    }
  },
  async mounted(){
    this.nav = await NavigationList.getByName("footer");

    await this.$nextTick();
    //this.loadKlaviyo();
  },
  methods: {
    //loadKlaviyo(){
    //  const src = "https://static.klaviyo.com/onsite/js/W9WLgB/klaviyo.js?company_id=W9WLgB";
    //  if (document.querySelector(`script[src="${src}"]`)) return;
    //  const script = document.createElement("script");
    //  script.async = true;
    //  script.src = src;
    //  document.head.appendChild(script);
    //}
  }
}
</script>
